// stores/player/playerStore.js
import { defineStore } from 'pinia';
import { api } from '../../services/api';
import { useAuthStore } from '../auth'; // Necesitamos acceso al auth store

export const usePlayerStore = defineStore('player', {
  state: () => ({
    balance: 0,
    bonus_balance: 0, //cashback bonus
    previousBalance: 0,
    lastBalance: 0,
    playerConfig: null,
    user: null,
    isInitializing: false,
    websiteConfig: {
      status: null,
      type: null,
      maintenance_message: null
    },
    // Nuevo estado para notificaciones
    cashbackNotification: {
      show: false,
      type: null,
      messageKey: null,
      amount: 0
    },
    // Nueva estructura para notificaciones de jackpot
    jackpotNotification: {
      show: false,
      type: null,
      messageKey: null,
      amount: 0,
      jackpotName: null
    }
  }),

  actions: {
    // Obtener balance
    async getBalance() {
      try {
        const authStore = useAuthStore();
        const response = await api.get('/player/getPlayerBalance', {
          headers: {
            Authorization: `Bearer ${authStore.token}`
          }
        });
        this.balance = parseFloat(response.data.balance);
        this.bonus_balance = parseFloat(response.data.bonus_balance);
        return this.balance;
      } catch (error) {
        console.error('Error getting player balance:', error);
        return 0;
      }
    },

    // Obtener configuración del jugador
    async getPlayerConfig() {
      try {
        const response = await api.get('/player/config');
        if (response.data.success) {
          this.playerConfig = response.data.config;
          // console.log('🔄 Config loaded:', {
          //   type: this.playerConfig.website_type,
          //   status: this.playerConfig.website_status
          // });
        }
        return this.playerConfig;
      } catch (error) {
        console.error('Config Error:', error);
        return null;
      }
    },

    // ctualizar balance y manejar notificaciones (llamado desde el websocket)
    // Modificar updateBalance para manejar ambas versiones
updateBalance(newBalance, oldBalance, bonusBalance, notification = null) {
  // Determinar si estamos usando la versión antigua (2 parámetros) o nueva (4 parámetros)
  const isOldVersion = bonusBalance === undefined;
  
  if (isOldVersion) {
    // Versión antigua (2 parámetros)
    const parsedNewBalance = parseFloat(newBalance) || 0;
    const parsedOldBalance = parseFloat(oldBalance) || 0;
    
    console.log('💰 Balance Update (legacy):', {
      previousBalance: parsedOldBalance.toFixed(2),
      currentBalance: parsedNewBalance.toFixed(2),
      change: (parsedNewBalance - parsedOldBalance).toFixed(2)
    });
    
    this.balance = parsedNewBalance;
    if (this.user) {
      this.user.balance = parsedNewBalance;
      localStorage.setItem('user', JSON.stringify(this.user));
    }
  } else {
    // Versión nueva (4 parámetros)
    const newAmount = parseFloat(newBalance) || 0;
    const bonusAmount = parseFloat(bonusBalance) || 0;
    
    // Si el balance está cambiando, es una actualización real
    if (this.balance !== newAmount) {
      console.log('💰 Balance Update:', {
        previousBalance: this.balance.toFixed(2),     
        currentBalance: newAmount.toFixed(2),         
        bonusBalance: bonusAmount.toFixed(2),
        change: (newAmount - this.balance).toFixed(2),
        notification
      });
  
      // Solo actualizar cuando hay un cambio real
      this.balance = newAmount;
      this.bonus_balance = bonusAmount;
  
      if (this.user) {
        this.user.balance = newAmount;
        this.user.bonus_balance = bonusAmount;
        localStorage.setItem('user', JSON.stringify(this.user));
      }
  
      // Manejo de notificaciones según el tipo
      if (notification) {
        if (notification.type === 'customer_bonus_notification') {
          // Notificación de cashback (código existente)
          this.cashbackNotification = {
            show: true,
            type: notification.type,
            messageKey: notification.message_key,
            amount: notification.amount
          };
          console.log('✅ Notificación de cashback activada:', this.cashbackNotification);
        } 
        else if (notification.type === 'jackpot_win') {
          // Nueva estructura para notificaciones de jackpot
          this.jackpotNotification = {
            show: true,
            type: notification.type,
            messageKey: notification.message_key,
            amount: notification.amount,
            jackpotName: notification.jackpot_name
          };
          console.log('🎰 Notificación de jackpot activada:', this.jackpotNotification);
        }
      }
    } else {
      console.log('⚠️ Skipping duplicate balance update:', {
        current: this.balance,
        received: newAmount
      });
    }
  }
},

      // Función existente para limpiar notificaciones de cashback
    clearCashbackNotification() {
      this.cashbackNotification = {
        show: false,
        type: null,
        messageKey: null,
        amount: 0
      };
    },

    // Nueva función para limpiar notificaciones de jackpot
    clearJackpotNotification() {
      this.jackpotNotification = {
        show: false,
        type: null,
        messageKey: null,
        amount: 0,
        jackpotName: null
      };
    },
  
    
    // Inicializar datos del jugador
    async initialize() {
      if (this.isInitializing || this.playerConfig) {
        return
      }

      this.isInitializing = true
      try {
        await this.getPlayerConfig()
        await this.getBalance()
      } finally {
        this.isInitializing = false
      }
    }
  },

  getters: {
    isTerminalMode: (state) => {
      return state.playerConfig ? state.playerConfig.website_type === 'terminal' : null
    },
    websiteStatus: (state) => state.playerConfig?.website_status,
    maintenanceMessage: (state) => state.playerConfig?.maintenance_message,
    formattedBalance: (state) => {
      return Number(state.balance).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formattedBonusBalance: (state) => {
      return Number(state.bonus_balance).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    currencyPrefix: (state) => state.playerConfig?.currency_prefix || '',
      // Nuevo getter para la notificación de cashback
      hasActiveCashbackNotification: (state) => state.cashbackNotification.show,
       // Nuevo getter para jackpot
    hasActiveJackpotNotification: (state) => state.jackpotNotification.show
    }
  });
  
 